import { Link } from "react-router-dom";
import { useState } from "react";
import { Plus, ClipboardCheck, FileText, Wallet } from "lucide-react";
import MspShell from "../../components/msp/MspShell";

const TABS = ["Upcoming", "Past", "Saved"];
const TRIPS = [
  { id: "japan", title: "Japan Cherry Blossom", when: "Mar 27 – Apr 5, 2027", where: "Tokyo · Kyoto · Osaka", people: 4, tint: "bg-pink-100",
    img: "https://images.unsplash.com/photo-1522547902298-51566e4fb383?auto=format&fit=crop&w=800&q=70" },
  { id: "aus",   title: "Australia Adventure",  when: "Apr 20 – May 5, 2027", where: "Sydney · Melbourne · Uluru", people: 2, tint: "bg-amber-100",
    img: "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?auto=format&fit=crop&w=800&q=70" },
  { id: "india", title: "India Visit",           when: "Sep 21 – Nov 7, 2026", where: "Delhi · Kerala · Family", people: 3, tint: "bg-emerald-100",
    img: "https://images.unsplash.com/photo-1524492412937-b28074a5d7da?auto=format&fit=crop&w=800&q=70" },
];
const QUICK = [
  { to: "/msp/plan",       label: "Itinerary",  Icon: ClipboardCheck, hue: "bg-blue-50 text-blue-600" },
  { to: "/msp/checklists", label: "Checklist",  Icon: ClipboardCheck, hue: "bg-emerald-50 text-emerald-600" },
  { to: "/msp/documents",  label: "Documents",  Icon: FileText,       hue: "bg-rose-50 text-rose-600" },
  { to: "/msp/expenses",   label: "Expenses",   Icon: Wallet,         hue: "bg-amber-50 text-amber-600" },
];

export default function MspTrips() {
  const [tab, setTab] = useState("Upcoming");
  return (
    <MspShell title="My Trips" back={false} testid="msp-trips">
      <div className="grid grid-cols-3 rounded-2xl bg-white border border-slate-200 p-1" data-testid="msp-trips-tabs">
        {TABS.map((t) => (
          <button key={t} onClick={() => setTab(t)} data-testid={`msp-tab-${t.toLowerCase()}`}
            className={`py-2.5 rounded-xl text-sm font-700 transition ${tab === t ? "bg-blue-600 text-white shadow" : "text-slate-500 hover:text-slate-800"}`}>
            {t}
          </button>
        ))}
      </div>

      <div className="space-y-3" data-testid="msp-trip-list">
        {TRIPS.length === 0 ? (
          <div className="rounded-3xl border-2 border-dashed border-slate-300 bg-white p-8 text-center" data-testid="msp-trips-empty">
            <div className="w-14 h-14 mx-auto rounded-full bg-blue-50 grid place-items-center mb-3">
              <Plus className="w-6 h-6 text-blue-600" />
            </div>
            <div className="font-serif font-800 text-lg text-blue-900">No trips yet</div>
            <p className="text-sm text-slate-500 mt-1 max-w-xs mx-auto">
              Add your first trip and we'll pull a matching cover photo, build a countdown and start your Inner Circle.
            </p>
            <Link to="/msp/plan" data-testid="msp-trips-plan-cta"
              className="mt-4 inline-flex items-center gap-1.5 bg-blue-600 text-white font-800 text-sm px-5 py-2.5 rounded-full hover:bg-blue-700">
              <Plus className="w-4 h-4" /> Plan a trip
            </Link>
          </div>
        ) : (TRIPS.map((t) => (
          <Link key={t.id} to="/travel-hub" data-testid={`msp-trip-${t.id}`}
            className="flex items-stretch bg-white rounded-3xl overflow-hidden border border-slate-200 shadow-sm hover:shadow-md transition">
            <div className={`w-28 shrink-0 ${t.tint} relative`}>
              <img src={t.img} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
            </div>
            <div className="flex-1 p-4 min-w-0">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-serif font-800 text-lg text-blue-900 leading-tight truncate">{t.title}</div>
                  <div className="text-xs text-slate-500 mt-1">{t.when}</div>
                  <div className="text-sm text-slate-700 mt-1 truncate">{t.where}</div>
                </div>
                <span className="text-[10px] font-mono uppercase tracking-widest bg-blue-50 text-blue-700 px-2 py-1 rounded-full">{tab}</span>
              </div>
              <div className="text-xs text-slate-500 mt-2">{t.people} Travelers</div>
            </div>
          </Link>
        )))}
      </div>

      <Link to="/msp/plan" data-testid="msp-create-trip"
        className="w-full inline-flex items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-blue-300 text-blue-700 font-700 py-3 hover:bg-blue-50">
        <Plus className="w-4 h-4" /> Create a New Trip
      </Link>

      <div>
        <div className="text-sm font-700 text-slate-700 mb-2">Quick Tools</div>
        <div className="grid grid-cols-4 gap-3">
          {QUICK.map(({ to, label, Icon, hue }) => (
            <Link key={label} to={to} data-testid={`msp-quick-${label.toLowerCase()}`}
              className="rounded-2xl bg-white border border-slate-200 p-3 text-center hover:shadow-sm transition">
              <span className={`inline-grid place-items-center w-10 h-10 rounded-xl ${hue} mb-1.5`}><Icon className="w-5 h-5" /></span>
              <div className="text-xs font-600 text-slate-700">{label}</div>
            </Link>
          ))}
        </div>
      </div>
    </MspShell>
  );
}
